<template>
  <!-- 修改部门弹框组件 -->
  <div class="changeBumen">
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="170">
      <FormItem label="部门名称：" prop="name" class="bumenModal-item">
        <Input v-model="formValidate.name" placeholder="请输入部门名称" />
      </FormItem>
      <FormItem label="上级部门：" prop="city" class="bumenModal-item">
        <Input search enter-button="选择" v-model="formValidate.city" @on-search="selectIshow" readonly placeholder="请选择上级部门" />
      </FormItem>

      <Modal v-model="bumenModal1" width="700px" footer-hide title="选择部门" class="secondBumen">
        <!-- :operations="operations" -->
        <Transfer ref="Transfer" :titleObj="titleObj" @setbumenModal="setbumenModal" @setData="setData"></Transfer>
      </Modal>

      <div class="bumen-button-conts">
        <Button class="btn" type="success" v-show="isDelet" ghost @click="clearBumen('formValidate')">删除部门</Button>
        <Button class="btn" type="success" ghost @click="handleReset('formValidate')">取消</Button>
        <Button class="btn sure" type="success" ghost @click="handleSubmit('formValidate')">确定</Button>
      </div>
    </Form>

    <Modal class="ivumodal" width="500" v-model="sliceIshhow" title="删除确认">
      <div class="ivumodal-cont">
        请先将包含的下级部门迁移或删除!
      </div>
      <div slot="footer">
        <Button type="text" size="large" @click="ok">取消</Button>
        <Button type="primary" size="large" @click="ok">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import Transfer from './transfer';
import { getSubordinateList } from '../servers/api'
export default {
  name: "changeBumen",
  props: {
    bumen: Boolean,
    titleObj: Object, //树形点击
  },
  components: {
    Transfer
  },
  data () {
    return {
      formValidate: {
        name: '',
        city: ''
      },
      ruleValidate: {
        name: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ],
        city: [
          { required: true, message: '请选择上级部门', trigger: 'change' }
        ],
      },//修改部门提示语和必填校验
      bumenModal1: false,
      isxinzeng: 0,//是否是新增下级部门 还是修改部门信息
      transferfromItem: {},//transfer传来的选中项
      isDelet: false,//控制删除按钮显示
      sliceIshhow: false,//删除弹框显示
      upitem: {}
    }
  },
  created () {
  },
  methods: {
    gettitleobj (item) {//获取点击树形传过来得值(1修改部门)
      this.isxinzeng = item.index;//1修改部门  2新增下级部门
      this.formValidate = item.formValidate;//每次弹框显示 添加里面得值为空 修改为点击的参数
      this.isDelet = item.isDelet;//修改部门有删除 按钮  为true显示删除按钮
      if (this.isxinzeng == 2) {
        this.transferfromItem = {
          structureName: item.formValidate.benname,
          id: item.formValidate.benid
        }
        this.formValidate.city = item.formValidate.benname
        // this.formValidate.name = item.formValidate.benid;
      } else {
        this.transferfromItem = {}
      }

    },
    setbumenModal (res) { //子组件传来弹框关闭
      this.bumenModal1 = res;
    },
    setData (res) {//子组件传来表单内容
      this.formValidate.city = res.structureName;
      this.transferfromItem = res;//拿到transfer得到得选择父级部门选项;
    },
    // 一级
    selectIshow () {//控制显示上级部门
      this.bumenModal1 = true;
      let list = []
      // 如果已经选中的选项再次去选择 就直接传参带过去 如果没有 直接查接口获取到上级拿上级
      // if(this.transferfromItem && this.transferfromItem.structureName){
      //     this.$refs.Transfer.getTitleone(this.titleObj,this.transferfromItem) //传树形
      // }else{
      let params = {
        structureId: this.formValidate.parentId || 1
      }
      getSubordinateList(params).then(res => {
        if (res.data.code == 1) {
          list = res.data.data.parentList.reverse();
          this.upitem = list[list.length - 1]
          this.$refs.Transfer.getTitleone(this.titleObj, this.upitem, this.transferfromItem) //传树形
        }
      })
      // }

    },
    handleSubmit (name) { //修改部门 确定校验
      this.$refs[name].validate((valid) => {
        if (valid) {
          let obj = {
            isshow: false, //关闭窗口
            data: this.formValidate,// 传值
            index: this.isxinzeng, //是修改还是新增
            transferfromItem: this.transferfromItem//transfer传来的选中项
          }
          this.$emit("changeBumen", obj);
        }
      })
    },
    clearBumen (name) {//删除部门
      this.$refs[name].validate((valid) => {
        if (valid) {
          let params = {
            structureId: this.formValidate.sessionId
          }
          getSubordinateList(params).then(res => {
            if (res.data.code == 1) {//有下级部门
              if (res.data.data.childList && res.data.data.childList.length > 0) {
                this.sliceIshhow = true;
              } else {
                this.$emit("changeBumen", '删除', this.formValidate.parentId)//父级id
              }
            }
          })
        }
      })
    },
    handleReset (name) {//修改部门取消
      this.upitem = {}
      this.transferfromItem = {}
      this.$refs[name].resetFields();
      this.$emit("changeBumen", false);
    },
    ok () {
      this.sliceIshhow = false;
    }
  }
}
</script>
<style lang="scss" scoped="" type="text/css">
@import "../css/conmmon.scss";
@import "../font/iconfont.css";
// 修改部门
.changeBumen {
  font-family: SimHei;
}
.bumenModal {
  .bumenModal-item {
    margin-bottom: 20px;
  }
  .bumen-button-conts {
    width: calc(100% - 15px);
    padding-left: 15px;
    text-align: center;
    justify-content: space-between;
    margin-top: 15px;
    .btn {
      margin-left: 15px;
      width: 80px;
    }
    .sure {
      background: #53cac3;
      color: #fff;
    }
    .sure:hover {
      background: #53cac3;
      color: #fff;
    }
  }
}
.secondBumen {
  width: 700px;
}
</style>





// WEBPACK FOOTER //
// src/components/tan/changeBumen.vue